// @flow

import React, {
  // $FlowFixMe
  useEffect,
  // $FlowFixMe
  useMemo,
  // $FlowFixMe
  useState,
  // $FlowFixMe
  useCallback,
  // $FlowFixMe
  useRef,
  Fragment
} from "react";
import mediator from "@tvg/mediator";
import {
  get,
  isEqual,
  noop,
  pull,
  isNumber,
  remove,
  forEach,
  first,
  flowRight as compose
} from "lodash";
import type { Dispatch } from "redux";
import { connect, useSelector } from "react-redux";
import { graphql } from "@apollo/client/react/hoc";
import RaceCardSort from "@fdr/racecard-sort";
import RunnerInfo from "@fdr/program-page-runner-info";
import { type RaceCardProps, type HelpTypeEnum } from "@fdr/types/ProgramPage";
import BetSelectionUtils from "@tvg/utils/betSelectionUtils";
import ApolloContext from "@tvg/utils/apolloContext";
import HelpModal from "@fdr/program-page-help";
import tvgConf from "@tvg/conf";
import RaceAlerts from "@fdr/race-alerts";
import { onOpenComplianceModal } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import { isMobile, isXSell } from "@tvg/sh-utils/mobileUtils";
import { isAccountCompliantSelector } from "@tvg/sh-utils/sessionUtils";
import {
  setStartBetting,
  resetBetting,
  setSelectionRequest,
  setPickLeg,
  setSelectionScratched,
  setBetTicketState,
  resetSelection,
  setBetState
} from "@tvg/shared-actions/BetActions";
import {
  useLastValue,
  useBettingInsterestsOrder
} from "@fdr/custom-hooks/ProgramPage";
import {
  setRace,
  setLoadingRunners,
  setOpenAllRunners,
  setSelectedRunners,
  shouldUpdatePicks
} from "@fdr/shared-actions/ProgramPageActions";
import { usePrevious } from "@fdr/custom-hooks/customHooks";
import {
  type RaceProgram,
  type RaceCardBettingInterest,
  type RunnerTagsModalProps
} from "@tvg/types/Race";
import {
  BetTypeTutorialsEnum,
  BetBasicInfo,
  BetRepeatInfo
} from "@tvg/ts-types/Bet";
import { getIsMyBetsOpen } from "@tvg/sh-lib-my-bets/redux/selectors";
import { getBalance, getAccountNumber } from "@urp/store-selectors";
import RaceCardTemplate from "@fdr/atomic-ui/_templates/RaceCard";
import RunnerTagsModal from "@fdr/atomic-ui/_templates/RunnerTagsModal";
import { doesSilkLoads } from "@tvg/sh-utils/raceUtils";
import { getNumberSuffix, getWPSLabel } from "@fdr/utils/raceUtils";
import {
  FREE_PICK_SOURCE,
  getFreePickSource,
  isSRW,
  isRAS
} from "@fdr/utils/trackDataSourceUtils";
import { WagerTypes } from "@fdr/types/WagerTypes";
import {
  shouldShowOnboarding,
  setComponentStatus
} from "@fdr/utils/onboardingUtils";
import { sortRunnersSelections } from "@tvg/api/wtx/BetHelper";
import { TalentPicksPgP } from "@urp/talent-picks";

import { events as AlchemerEvents } from "@urp/alchemer";
import parseJSONCapiMessage from "@fdr/utils/parseJSONCapiMessage";
import BetsModal from "@tvg/pp/src/components/BetsModal";
import RepeatBetModal from "@tvg/pp/src/components/RepeatBetModal";
import ApolloOptions from "./graphql/options.graph";
import RacecardQuery from "./graphql/queries/RacecardQuery.graphql";
import RaceCardSubscription from "./graphql/queries/RaceCardSubscription.graphql";

export const changeRace = (action: string, destinationUrl: string) => {
  mediator.base.dispatch({
    type: "RACE_RESULTS_CHANGE_RACE",
    payload: {
      actionName: action,
      destinationUrl,
      module: "Racecard"
    }
  });
};

export const onRunnerTagsModalGTM = (
  runnerName: string,
  raceNumber?: string,
  runnerTagsVisible?: string,
  trackName?: string,
  open: boolean
) => {
  mediator.base.dispatch({
    type: `PROGRAM_RUNNER_INFO_MODAL_${open ? "OPENED" : "CLOSED"}`,
    trackName,
    runnerTagsVisible,
    raceNumber,
    runnerName
  });
};

export const onBoardingSeenGTM = (onBoardingType: string) => {
  mediator.base.dispatch({
    type: "PICK_BETS_ONBOARDING_SEEN",
    payload: {
      onBoardingType
    }
  });
};

export const getRunnersNumbers = (
  bettingInterest: RaceCardBettingInterest[]
) => {
  let numberOfScratches = 0;
  let numberOfRunners = 0;

  bettingInterest.forEach((bi) =>
    bi.runners.forEach((runner) => {
      numberOfRunners += 1;
      if (runner.scratched) {
        numberOfScratches += 1;
      }
    })
  );
  return { runners: numberOfRunners, scratches: numberOfScratches };
};

const initialRunnerTagsData = {
  isOpen: false,
  currentRunnerTags: [],
  linkedRunner: {},
  raceNumber: "1",
  trackName: "",
  concatRunnerTags: ""
};

// WHEN USER CHANGES OPEN STATE ON RUNNER LINE
export const changeUpdate = ({
  id,
  leg,
  selectedRunners,
  isLogged,
  isAccountCompliant,
  dispatch,
  isAllRunnersOpen,
  bettingInterests
}: {
  id: string,
  leg: number,
  selectedRunners: string[][],
  isLogged: boolean,
  isAccountCompliant?: boolean,
  dispatch: Dispatch<*>,
  isAllRunnersOpen: boolean[],
  bettingInterests: RaceCardBettingInterest[][]
}) => {
  let removedRunner = false;
  const copySelectedRunners = selectedRunners.slice();

  if (
    copySelectedRunners[leg] &&
    copySelectedRunners[leg].find((item) => id === item)
  ) {
    mediator.base.dispatch({
      type: "RUNNER_INFO:EXPAND_COLLAPSE",
      payload: {
        expandAction: "Collapse",
        runnerId: id
      }
    });

    const legArray = copySelectedRunners[leg].slice();
    pull(legArray, id);
    copySelectedRunners[leg] = legArray;
    removedRunner = true;
  } else if (isNumber(leg)) {
    mediator.base.dispatch({ type: "RACEPAGE_DETAILS_EXPANDED" });
    mediator.base.dispatch({
      type: "RUNNER_INFO:EXPAND_COLLAPSE",
      payload: {
        expandAction: "Expand",
        runnerId: id
      }
    });
    AlchemerEvents.selectInlinePastPerformance();
    const legArray = copySelectedRunners[leg].slice();
    legArray.push(id);

    copySelectedRunners[leg] = legArray;

    if (!isLogged) {
      mediator.base.dispatch({
        type: "OPEN_LOGIN",
        payload: {
          callback: () => {
            dispatch(setSelectedRunners(copySelectedRunners.slice()));
          }
        }
      });
      return;
    }

    if (!isAccountCompliant) {
      onOpenComplianceModal();
      return;
    }
  }
  dispatch(setSelectedRunners(copySelectedRunners.slice()));

  if (removedRunner) {
    dispatch(shouldUpdatePicks(true));
    const allOpenArray = isAllRunnersOpen.slice();
    allOpenArray[leg] = false;
    dispatch(setOpenAllRunners(allOpenArray));
  }

  const { runners, scratches } = getRunnersNumbers(bettingInterests[leg]);

  const allRunnersSelected =
    get(copySelectedRunners, `[${leg}].length`) === runners - scratches;

  if (allRunnersSelected) {
    dispatch(shouldUpdatePicks(true));
    const allOpenArray = isAllRunnersOpen.slice();
    allOpenArray[leg] = true;
    dispatch(setOpenAllRunners(allOpenArray));
  }
};

export const openBetReceiptModal = (
  tvgRaceId: number,
  dispatch: Dispatch<*>,
  setIsBetsModalOpen: (isOpen: boolean) => void,
  isAccountCompliant?: boolean
) => {
  if (isAccountCompliant) {
    setIsBetsModalOpen(true);
    dispatch({
      type: "MYBETS_SET_RACE",
      payload: tvgRaceId
    });
    dispatch({
      type: "ACTIVE_BETS_OPEN"
    });

    mediator.base.dispatch({
      type: "RACE_ACTIVE_BETS_MODAL_OPEN",
      payload: null
    });
  }
};

const onTooltipClick = () => {
  mediator.base.dispatch({
    type: "PPM_TOOLTIP_CLICKED"
  });
};

export const getRaceToBetsModal = (race: RaceProgram) => ({
  ...race,
  bettingInterests: get(race, "bettingInterests[0]") || []
});

export const RaceCard = (props: RaceCardProps) => {
  const {
    bettingInterests,
    wagerType,
    race,
    betSelections,
    dispatch,
    isBetTicketOpen,
    subscribeToMore,
    wagerProfile,
    userSetHandicappingSortMode,
    currentRace,
    isLogged,
    isAccountCompliant,
    racesData,
    races,
    isWagerable,
    updatePicks,
    isLoading,
    isAllRunnersOpen,
    selectedRunners,
    isLoadingPP,
    numberFirePrediction,
    hasWebSockets,
    betLeg,
    betAmount,
    singleOddsOrder,
    timeformForUSGSA,
    winGroupLayout,
    isResulted,
    racesActiveBets,
    hasProgramPageActiveBetsReceipt,
    isBettingModalOpen,
    showOnboardingInfo,
    showSilks,
    runnerSelectionCallback,
    pickBetsOnboardingToggle,
    firstTimeOnboardingToggle,
    useGraphStatusV2,
    showRunnerUpdate,
    accountNumber,
    enableNewRacePage,
    wagerTypeHelpHidden,
    history,
    runnerTags,
    selectAllButtonLabel,
    videoCarouselData,
    raceDate
  } = props;

  const sortedBettingInterest = useBettingInsterestsOrder(
    bettingInterests,
    race.id || "",
    userSetHandicappingSortMode,
    singleOddsOrder && !isLoading
  );

  const [hasRequested, setRequested] = useState(false);
  const [isHelpModalOpen, setHelpModalOpen] = useState(false);
  const [helpModalType, setHelpModalType] = useState("PWR RATING");
  const [hasSubscription, setHasSubscription] = useState(null);
  const [hasActiveBet, setHasActiveBet] = useState(0);
  const [hasNotApplicableDesc, setNotApplicableDesc] = useState(false);
  const [showSilksState, setShowSilksState] = useState(showSilks);
  const [
    shouldShowFirstOnboardingRunnerInfo,
    setShouldShowFirstOnboardingRunnerInfo
  ] = useState(shouldShowOnboarding("runner-info"));
  const [isInfoBannerVisible, setInfoBannerVisible] = useState(false);
  const [raceAnalystVerdictExpanded, setRaceAnalystVerdictExpanded] =
    useState(false);
  const [runnerTagsModalProps, setRunnerTagsModalProps] =
    useState<RunnerTagsModalProps>(initialRunnerTagsData);
  const [isRepeatBetModalOpen, setIsRepeatBetModalOpen] = useState(false);
  const [isBetsModalOpen, setIsBetsModalOpen] = useState(false);
  const [selectedRaceWager, setSelectedRaceWager] = useState<
    BetBasicInfo | BetRepeatInfo | null
  >(null);

  const myBetsIsOpen = useSelector(getIsMyBetsOpen);
  const userBalance = useSelector(getBalance);
  const prevLoadingState = useRef(false);

  const lastBi = useLastValue(bettingInterests);
  const lastLegCount = useLastValue(get(wagerType, "legCount"));
  const lastRaceId = useLastValue(get(currentRace, "id"));

  const closeHelpModal = () => {
    setHelpModalOpen(false);
  };

  const openHelpModal = (type: HelpTypeEnum, isNotApplicable?: boolean) => {
    setNotApplicableDesc(isNotApplicable);
    setHelpModalOpen(true);
    setHelpModalType(type);
  };

  const setOnboardingStatus = (componentName: string, action: string) => {
    setComponentStatus(componentName, action);
    const newOnboardingState = shouldShowOnboarding("runner-info");
    if (shouldShowFirstOnboardingRunnerInfo !== newOnboardingState)
      setShouldShowFirstOnboardingRunnerInfo(newOnboardingState);
  };

  const changeShouldUpdate = () => {
    dispatch(shouldUpdatePicks(false));
  };

  const insertAllRunnersSelection = useCallback(() => {
    const runners = [...selectedRunners];
    const allOpenArray = [...isAllRunnersOpen];
    forEach(bettingInterests[betLeg], (bettingItem) => {
      bettingItem.runners.forEach((runnerItem) => {
        const id = runnerItem.runnerId;
        if (
          selectedRunners[betLeg] &&
          !selectedRunners[betLeg].find((item) => id === item) &&
          isNumber(betLeg) &&
          !runnerItem.scratched
        ) {
          const legArray = [...runners[betLeg]];
          legArray.push(id);
          runners[betLeg] = legArray;
          allOpenArray[betLeg] = true;
        }
      });
    });

    dispatch(setSelectedRunners([...runners]));
    dispatch(setOpenAllRunners(allOpenArray));

    mediator.base.dispatch({
      type: "RUNNER_INFO:EXPAND_COLLAPSE",
      payload: {
        expandAction: "Expand",
        runnerId: "all"
      }
    });
  }, [
    betLeg,
    JSON.stringify(selectedRunners),
    JSON.stringify(bettingInterests),
    JSON.stringify(isAllRunnersOpen)
  ]);

  useEffect(() => {
    if (shouldShowFirstOnboardingRunnerInfo)
      setOnboardingStatus("runner-info", "seen");
  }, []);

  // reset betting on track change
  useEffect(() => {
    const array = Array(get(wagerType, "legCount ", 1)).fill([]);
    const allSelectedArray = Array(get(wagerType, "legCount ", 1)).fill(false);
    dispatch(setOpenAllRunners(allSelectedArray));
    dispatch(setSelectedRunners(array));
    dispatch(shouldUpdatePicks(true));
    dispatch(resetSelection());
    dispatch(setBetState("none"));
    dispatch(setPickLeg(0));
  }, [race.id]);

  useEffect(() => {
    dispatch(resetBetting());
  }, [get(race, "track.trackCode")]);

  const prevWagerType = usePrevious(get(wagerType, "type.id"));
  const [savedSelections, setSavedSelections] = useState([]);

  // reset betting on wager type change
  useEffect(() => {
    if (wagerType) {
      const { legCount } = wagerType;

      // Reset runner selections
      if (selectedRunners && selectedRunners.length !== legCount) {
        const arrayLength = legCount - selectedRunners.length;
        let newSelectedRunners;
        if (arrayLength > 0) {
          const array = Array(arrayLength).fill([]);
          newSelectedRunners = selectedRunners.concat(array);
        } else {
          newSelectedRunners = selectedRunners.slice(0, wagerType.legCount);
        }
        dispatch(setSelectedRunners(newSelectedRunners));
      }

      BetSelectionUtils.configureProgramPageByBetType(
        get(wagerType, "columnCount"),
        get(wagerType, "legCount"),
        get(wagerType, "type.id"),
        betSelections,
        dispatch,
        false // no talent pick for now
      );

      dispatch(shouldUpdatePicks(true));
    }
  }, [get(wagerType, "type.id")]);

  // resets bet Leg to first when wager type changes
  useEffect(() => {
    dispatch(setPickLeg(0));
  }, [get(wagerType, "type.id")]);

  useEffect(() => {
    if (
      currentRace &&
      bettingInterests &&
      bettingInterests.length > 0 &&
      !isLoading
    ) {
      const newCurrentRace = { ...currentRace, bettingInterests };
      // The Betting interest on race object and the betting interest on racecard have different types, only needed to fix bet ticket
      // $FlowFixMe
      dispatch(setRace(newCurrentRace));
    }
  }, [JSON.stringify(bettingInterests), currentRace.id, isLoading]);

  useEffect(() => {
    if (
      get(wagerType, "legCount") === lastLegCount &&
      get(currentRace, "id") === lastRaceId &&
      bettingInterests.join().length === (lastBi || []).join().length &&
      !isEqual(bettingInterests, lastBi)
    ) {
      const diffArr = [];
      const newSelection = [];

      for (let i = 0; i < get(wagerType, "columnCount"); i += 1) {
        newSelection.push([]);
      }

      for (let i = 0; i < get(wagerType, "legCount"); i += 1) {
        diffArr.push([]);
      }

      bettingInterests.forEach((bettingInt, indexTop) =>
        bettingInt.forEach((bi, indexMed) =>
          bi.runners.forEach((runner, ind) => {
            const isScratched = get(
              lastBi,
              `[${indexTop}][${indexMed}].runners[${ind}].scratched`
            );
            const diffArrayIndex =
              get(wagerType, "legCount") > 1 ? indexTop : 0;
            return (
              runner.scratched !== isScratched &&
              diffArr[diffArrayIndex] &&
              diffArr[diffArrayIndex].push(runner.runnerId)
            );
          })
        )
      );

      betSelections.forEach((selections, index: number) =>
        selections.forEach(
          (selection) =>
            !diffArr[get(wagerType, "legCount") > 1 ? index : 0].includes(
              selection.toString()
            ) && newSelection[index].push(selection)
        )
      );

      if (newSelection.join().length !== betSelections.join().length) {
        // set new selections
        dispatch(setSelectionRequest(newSelection));
        dispatch(setStartBetting());
        // set scratched runners
        dispatch(setSelectionScratched(diffArr));
      }
    }
  }, [JSON.stringify(bettingInterests)]);

  useEffect(() => {
    if (subscribeToMore) {
      if (typeof hasSubscription === "function") {
        hasSubscription();
      }

      const unsubscribe = subscribeToMore({
        document: RaceCardSubscription,
        variables: {
          trackAbbr: get(race, "track.trackCode", "").toUpperCase(),
          wagerProfile,
          raceNumber: +get(race, "raceNumber", "") - 1,
          numOfRaces: +get(wagerType, "legCount", 1)
        }
      });
      setHasSubscription(() => unsubscribe);
    }
  }, [race.raceNumber, subscribeToMore]);

  useEffect(() => {
    if (!isLoading) {
      setRequested(true);
      dispatch(setLoadingRunners(false));
    } else {
      setRequested(false);
      dispatch(setLoadingRunners(true));
    }
    prevLoadingState.current = isLoading;
  }, [isLoading]);

  useEffect(() => {
    if (isAllRunnersOpen[betLeg] && bettingInterests.length > 0) {
      insertAllRunnersSelection();
    }
  }, [JSON.stringify(isAllRunnersOpen)]);

  useEffect(() => {
    setHasActiveBet(racesActiveBets[get(currentRace, "tvgRaceId")]);
  }, [racesActiveBets, currentRace]);

  useEffect(() => {
    if (bettingInterests.length > 1 && showOnboardingInfo) {
      onBoardingSeenGTM(get(wagerType, "type.name", ""));
    }
  }, [showOnboardingInfo, JSON.stringify(props.bettingInterests)]);

  const fetchSilksData = async () => {
    if (bettingInterests.length) {
      const result = await doesSilkLoads(bettingInterests, true);
      setShowSilksState(showSilks && result);
    }
  };

  useEffect(() => {
    fetchSilksData();
  }, [JSON.stringify(props.bettingInterests)]);

  useEffect(() => {
    const isSpecialGroup = get(wagerType, "specialGroup", false);
    const currentWagerType = get(wagerType, "type.id");
    // Check if is on a Win -> WPS and and maintain runners selected
    if (isSpecialGroup && prevWagerType === WagerTypes.Win) {
      const firstSelectedRunners = get(savedSelections, "[0]", []);
      if (firstSelectedRunners.length > 0) {
        const selectionColumnLength =
          currentWagerType === WagerTypes.WinPlace ? 2 : 3;
        const selectionColumn = new Array(selectionColumnLength).fill([]);
        selectionColumn[0] = firstSelectedRunners;
        dispatch(setSelectionRequest(selectionColumn));
      }
    }

    if (currentWagerType === WagerTypes.Win) {
      setSavedSelections(betSelections);
    } else {
      setSavedSelections([]);
    }

    // Clear errors when bet confirmation is off
    dispatch(
      setBetTicketState(
        ({
          isProcessing: false,
          isBettingError: false
        }: any)
      )
    );
  }, [JSON.stringify(betSelections), wagerType]);

  const runnerSelectGtm = (
    add: boolean,
    selection: string,
    column: number = -1
  ) => {
    const getLabel = (col, type, sel) => {
      if (type === "EX" || type === "TR" || type === "SU" || type === "SH5") {
        const runnerPlace = col + 1;

        if (runnerPlace !== 0) {
          const suffix = getNumberSuffix(runnerPlace);
          return `${runnerPlace + suffix}`;
        }

        return "Any";
      }
      if (type === "WPS" || type === "WP") {
        const label = getWPSLabel(col);
        return label;
      }

      const selected = first(
        get(props, `currentRace.bettingInterests[${col}]`, []).filter(
          (selectedHorse) => selectedHorse.biNumber === +sel
        )
      );

      const numerator =
        get(selected, "currentOdds.numerator", null) !== null
          ? selected.currentOdds.numerator
          : 1;

      const denominator =
        get(selected, "currentOdds.denominator", null) !== null
          ? selected.currentOdds.denominator
          : 1;

      return `${numerator}/${denominator}`;
    };

    const betType = get(props, "wagerType.type.code");

    mediator.base.dispatch({
      type: "PPM_RUNNER_SELECTION_2",
      payload: {
        action: add ? "Add To Betslip" : "Remove From Betslip",
        race: props.currentRace,
        label: getLabel(column, betType, selection),
        betType: get(props, "wagerType.type.code"),
        tag: selection
      }
    });
  };

  const onRunnerSelect = (selection: string, column: number = 0) => {
    let columnSelection = [];

    const isAllSelected = betSelections.every((biColumn) =>
      biColumn.includes(selection)
    );

    let newBetSelections = betSelections.slice();

    if (
      isAllSelected &&
      get(wagerType, "columnCount") > 1 &&
      get(wagerType, "legCount") === 1
    ) {
      newBetSelections = betSelections.map((biColumn) => {
        if (biColumn.find((el) => el === selection)) {
          return pull([...biColumn], selection);
        }
        return [...biColumn];
      });
    }

    const findSelection = newBetSelections[column].find(
      (runner: string) => runner === selection
    );

    if (findSelection) {
      columnSelection = newBetSelections[column].filter(
        (runnerId: string) => runnerId !== selection
      );
      runnerSelectGtm(false, selection, column);
    } else {
      columnSelection = newBetSelections[column].slice();
      columnSelection.push(selection);
      runnerSelectGtm(true, selection, column);
    }

    columnSelection = columnSelection.sort(sortRunnersSelections);
    // replace old column with new on the matrix
    const newSelection = newBetSelections.slice();

    // handle keys

    newSelection[column] = columnSelection;

    // save matrix on redux store
    dispatch(setSelectionRequest(newSelection));

    if (newSelection.every((array) => array.length === 0)) {
      dispatch(setStartBetting(false));
    } else if (!isBetTicketOpen) {
      dispatch(setStartBetting(true));
    }

    if (runnerSelectionCallback) {
      runnerSelectionCallback();
    }
  };

  const selectAllRunnerEntries = (biNumber: string) => {
    const isAllSelected = betSelections.every((column) =>
      column.includes(biNumber)
    );
    let newBetSelections = betSelections.slice();

    if (!isAllSelected) {
      newBetSelections = betSelections.map((column) => {
        if (!column.find((el) => el === biNumber)) {
          return [...column, biNumber];
        }
        return column;
      });
      runnerSelectGtm(true, biNumber);
    } else {
      newBetSelections = betSelections.map((column) => {
        if (column.find((el) => el === biNumber)) {
          return remove([...column], (el) => el !== biNumber);
        }
        return column;
      });
      runnerSelectGtm(false, biNumber);
    }

    dispatch(setSelectionRequest(newBetSelections));

    if (newBetSelections.every((array) => array.length === 0)) {
      dispatch(setStartBetting(false));
    } else if (!isBetTicketOpen) {
      dispatch(setStartBetting(true));
    }
  };

  const setBetPickLeg = (leg: number = 0) => {
    dispatch(setPickLeg(leg));
  };

  const getGroup = (wagerTypeId: number, groupEnabled: boolean) =>
    groupEnabled &&
    (wagerTypeId === WagerTypes.WinPlace ||
      wagerTypeId === WagerTypes.WinShow ||
      wagerTypeId === WagerTypes.WinPlaceShow)
      ? "winGroup"
      : null;

  const numColumns =
    get(wagerType, "legCount", 1) > 1 ? 1 : betSelections.length;

  const expandedInfo = (
    runnerId: number,
    leg: number,
    isNumberFireSection: boolean
  ) => {
    const runner = bettingInterests[leg].find((bettingInterest) =>
      bettingInterest.runners.find(
        (runnerItem) => runnerItem.runnerId === runnerId
      )
    );

    const firstRunnerId = get(
      first(first(sortedBettingInterest)),
      "runners[0].runnerId"
    );
    const isFirstRunner = +runnerId === +firstRunnerId;
    const hasOfficialResults = get(race, "status.code", "") === "RO";

    return (
      <ApolloContext.Consumer>
        {(value) => (
          <RunnerInfo
            key={runnerId}
            hasWebSockets={hasWebSockets}
            runnerId={runnerId}
            wagerProfile={wagerProfile}
            fcpClient={get(value, "fcpClient")}
            behgClient={get(value, "behgClient")}
            runner={runner}
            betLeg={leg}
            bettingInterests={sortedBettingInterest}
            race={races[leg + +get(race, "raceNumber") - 1]}
            openHelpModal={openHelpModal}
            closeHelpModal={closeHelpModal}
            helpModalType={helpModalType}
            isHelpModalOpen={isHelpModalOpen}
            shouldShowFirstOnboarding={
              firstTimeOnboardingToggle && isFirstRunner
            }
            isAllRunnersOpen={get(isAllRunnersOpen, "[0]", false)}
            onTooltipClick={onTooltipClick}
            isNumberFireSection={isNumberFireSection}
            numColumns={numColumns}
            showRunnerUpdate={showRunnerUpdate}
            isWagerable={isWagerable}
            showWinProb={!hasOfficialResults}
          />
        )}
      </ApolloContext.Consumer>
    );
  };

  useEffect(() => {
    const wagerTypeCode = get(wagerType, "type.code", "");
    const availableTutorials = Object.values(BetTypeTutorialsEnum);
    setInfoBannerVisible(
      !wagerTypeHelpHidden.split(",").includes(wagerTypeCode) &&
        availableTutorials.includes(wagerTypeCode)
    );
  }, [wagerType, wagerTypeHelpHidden]);

  function computeCorrectArticleWithBetType(betType) {
    const betName =
      ["a", "e", "i", "o", "u"].indexOf(betType.toLowerCase()[0]) !== -1
        ? `an ${betType}`
        : `a ${betType}`;

    const pickBetNumber = betName ? betName.replace(/\D/g, "") : 0;
    if (pickBetNumber) {
      window.localStorage.setItem("PICK_BET_NUMBER", pickBetNumber);
    }

    return betName;
  }

  const getInfoBannerLink = () => {
    const path = get(history, "location.pathname", "");
    const parameters = get(history, "location.search", "");
    return {
      text: `Learn how ${computeCorrectArticleWithBetType(
        get(wagerType, "type.name", "")
      )} bet works`,
      url: `${path}${parameters}#understandingBetTypes`
    };
  };

  const onRaceTagsInfoClick = (info: RunnerTagsModalProps) => {
    onRunnerTagsModalGTM(
      info.linkedRunner.horseName,
      info.raceNumber,
      info.concatRunnerTags,
      info.trackName,
      true
    );

    setRunnerTagsModalProps({
      isOpen: true,
      linkedRunner: info.linkedRunner,
      currentRunnerTags: info.currentRunnerTags,
      trackName: info.trackName,
      raceNumber: info.raceNumber,
      concatRunnerTags: info.concatRunnerTags
    });
  };

  const handleRepeatWager = (raceWager: BetBasicInfo | BetRepeatInfo) => {
    setSelectedRaceWager(raceWager);
    setIsRepeatBetModalOpen(true);
  };

  return useMemo(() => {
    const trackDataSource = get(race, "track.trackDataSource", "");
    const freePickSource = timeformForUSGSA
      ? getFreePickSource(trackDataSource)
      : FREE_PICK_SOURCE.DEFAULT;
    const hasNumberFirePredictions =
      get(props, "bettingInterests[0]", []).filter(
        (bi) =>
          get(bi, `runners[0].${freePickSource}.freePick.number`, null) !== null
      ).length > 0;
    return (
      <Fragment>
        <RaceCardTemplate
          onRaceTagsInfoClick={(info) => onRaceTagsInfoClick(info)}
          updatePicks={updatePicks}
          openHelpModal={openHelpModal}
          hasProgramPageActiveBetsReceipt={hasProgramPageActiveBetsReceipt}
          openBetReceiptModal={() =>
            openBetReceiptModal(
              get(race, "tvgRaceId", 0),
              dispatch,
              setIsBetsModalOpen,
              isAccountCompliant
            )
          }
          activeBetsCounter={hasActiveBet}
          changeRace={(action: string, destinationUrl: string) =>
            changeRace(action, destinationUrl)
          }
          betAmount={betAmount}
          renderSortComponent={() => (
            <RaceCardSort sortType={userSetHandicappingSortMode} />
          )}
          changeShouldUpdate={changeShouldUpdate}
          selectedRunners={selectedRunners}
          hasRequested={hasRequested}
          changeUpdate={(id: string, leg: number) =>
            changeUpdate({
              id,
              leg,
              selectedRunners,
              isLogged,
              isAccountCompliant,
              dispatch,
              isAllRunnersOpen,
              bettingInterests
            })
          }
          expandedInfo={expandedInfo}
          racesData={racesData}
          raceTypeCode={get(props, "race.type.code", "T")}
          isLogged={isLogged}
          selectedLeg={props.betLeg}
          onLegSelect={setBetPickLeg}
          onRunnerSelect={onRunnerSelect}
          isWagerable={isWagerable}
          selections={betSelections}
          bettingInterests={sortedBettingInterest}
          race={race}
          races={races}
          numLegs={get(wagerType, "legCount", 1)}
          numColumns={
            get(wagerType, "legCount", 1) > 1 ? 1 : betSelections.length
          }
          onSelectAllRunnerEntries={selectAllRunnerEntries}
          hasRaceAlertsBar={
            isMobile(tvgConf().product) &&
            isLogged &&
            isWagerable &&
            !isXSell(tvgConf.product)
          }
          renderRaceAlerts={(
            hasTopMargin: boolean,
            tvgRaceId: number,
            leg: number
          ) => (
            <RaceAlerts
              hasTopMargin={hasTopMargin}
              showBottomBorder={!hasTopMargin}
              showTopBorder={!hasTopMargin}
              tvgRaceId={tvgRaceId}
              raceTrackCode={get(race, "track.trackCode", "")}
              raceNumber={leg + +get(race, "raceNumber", "")}
              racePostTime={get(race, "postTime", "")}
            />
          )}
          numberFirePrediction={numberFirePrediction}
          hasNumberFirePredictions={hasNumberFirePredictions}
          isSRW={isSRW(trackDataSource)}
          isRAS={isRAS(trackDataSource)}
          freePickSource={freePickSource}
          raceAnalystVerdictExpanded={raceAnalystVerdictExpanded}
          setRaceAnalystVerdictExpanded={setRaceAnalystVerdictExpanded}
          useNewProgramPageLayout
          group={getGroup(get(wagerType, "type.id"), winGroupLayout)}
          wagerTypeCode={get(wagerType, "type.code")}
          fullWidth={winGroupLayout}
          isResulted={isResulted}
          isBettingModalOpen={isBettingModalOpen}
          showOnboardingInfo={showOnboardingInfo && pickBetsOnboardingToggle}
          showSilks={showSilksState}
          shouldShowFirstOnboarding={
            firstTimeOnboardingToggle && shouldShowFirstOnboardingRunnerInfo
          }
          onTooltipClick={onTooltipClick}
          setOnboardingStatus={setOnboardingStatus}
          useGraphStatusV2={useGraphStatusV2}
          showRunnerUpdate={showRunnerUpdate}
          accountNumber={accountNumber}
          isAccountCompliant={isAccountCompliant}
          enableNewRacePage={enableNewRacePage}
          isInfoBannerVisible={isInfoBannerVisible}
          infoBannerLink={getInfoBannerLink()}
          videoCarouselData={videoCarouselData}
          selectAllButtonLabel={selectAllButtonLabel}
          raceDate={raceDate}
          talentPicksComp={
            <TalentPicksPgP
              raceNumber={race.raceNumber}
              trackCode={race.track?.trackCode}
              wagerProfile={wagerProfile}
              races={races}
            />
          }
        />
        <HelpModal
          isOpen={isHelpModalOpen}
          type={helpModalType}
          closeModal={closeHelpModal}
          hasNotApplicableDesc={hasNotApplicableDesc}
          dispatch={dispatch}
        />
        <BetsModal
          isOpen={!myBetsIsOpen && isBetsModalOpen}
          onClose={() => setIsBetsModalOpen(false)}
          race={getRaceToBetsModal(race)}
          races={races}
          onRepeatWager={handleRepeatWager}
        />
        {selectedRaceWager && (
          <RepeatBetModal
            userBalance={userBalance}
            race={race}
            races={races}
            raceWager={selectedRaceWager}
            isRepeatBetModalOpen={isRepeatBetModalOpen}
            setRepeatBetModalOpen={setIsRepeatBetModalOpen}
          />
        )}
        <RunnerTagsModal
          onClose={() => {
            onRunnerTagsModalGTM(
              runnerTagsModalProps.linkedRunner.horseName,
              runnerTagsModalProps.raceNumber,
              runnerTagsModalProps.concatRunnerTags,
              runnerTagsModalProps.trackName,
              false
            );
            setRunnerTagsModalProps(initialRunnerTagsData);
          }}
          isOpen={runnerTagsModalProps.isOpen}
          linkedRunner={runnerTagsModalProps.linkedRunner}
          currentRunnerTags={runnerTagsModalProps.currentRunnerTags || []}
          runnerTags={runnerTags || []}
        />
      </Fragment>
    );
  }, [
    hasRequested,
    updatePicks,
    betAmount,
    helpModalType,
    isHelpModalOpen,
    props.betLeg,
    isLoadingPP,
    get(wagerType, "type.id"),
    isBetTicketOpen,
    userSetHandicappingSortMode,
    isLogged,
    showSilksState,
    get(race, "status.code"),
    get(race, "mtp"),
    JSON.stringify(selectedRunners),
    JSON.stringify(bettingInterests),
    JSON.stringify(betSelections),
    JSON.stringify(isAllRunnersOpen),
    numberFirePrediction,
    sortedBettingInterest,
    raceAnalystVerdictExpanded,
    shouldShowFirstOnboardingRunnerInfo,
    isInfoBannerVisible
  ]);
};

RaceCard.defaultProps = {
  bettingInterests: [],
  race: {},
  isLoading: true,
  wagerProfile: "FDR-Generic",
  subscribeToMore: noop,
  dispatch: noop,
  betSelections: [[]],
  isBetTicketOpen: false,
  wagerType: null,
  betLeg: 0,
  userSetHandicappingSortMode: "odds",
  isLogged: false,
  isAccountCompliant: false,
  currentRace: {},
  racesData: [],
  races: [],
  isWagerable: true,
  updatePicks: false,
  hasWebSockets: false,
  isAllRunnersOpen: [],
  selectedRunners: [[]],
  isLoadingPP: true,
  numberFirePrediction: false,
  programPageURLParams: false,
  singleOddsOrder: false,
  timeformForUSGSA: false,
  winGroupLayout: false,
  isResulted: false,
  racesActiveBets: {},
  showOnboardingInfo: true,
  showSilks: false,
  runnerSelectionCallback: noop,
  useGraphStatusV2: false,
  showRunnerUpdate: false,
  enableNewRacePage: false,
  wagerTypeHelpHidden: "",
  history: {},
  raceDate: ""
};

export default connect((store) => ({
  betAmount: get(store, "RaceProgram.betAmount"),
  currentRace: get(store, "RaceProgram.currentRace"),
  betLeg: get(store, "RaceProgram.betLeg", [[]]),
  betSelections: get(store, "RaceProgram.betSelections", [[]]),
  isBetTicketOpen: get(store, "RaceProgram.startBetting", false),
  userSetHandicappingSortMode: get(
    store,
    "RaceProgram.userSetHandicappingSortMode"
  ),
  isLogged: get(store, "userData.logged"),
  isAccountCompliant: isAccountCompliantSelector(store),
  accountNumber: getAccountNumber(store),
  updatePicks: get(store, "RaceProgram.updatePicks", false),
  isAllRunnersOpen: get(store, "RaceProgram.isAllRunnersOpen", []),
  selectedRunners: get(store, "RaceProgram.selectedRunners", [[]]),
  numberFirePrediction: get(store, "capi.featureToggles.numberFirePrediction"),
  pickBetsOnboardingToggle: get(
    store,
    "capi.featureToggles.pickBetsOnboarding",
    false
  ),
  singleOddsOrder: get(store, "capi.featureToggles.singleOddsOrder", false),
  timeformForUSGSA: get(store, "capi.featureToggles.timeformForUSGSA", false),
  winGroupLayout: get(store, "capi.featureToggles.winBetGroup", false),
  racesActiveBets: get(store, "myBetsStandalone.racesActiveBets", {}),
  hasProgramPageActiveBetsReceipt: get(
    store,
    "capi.featureToggles.programPageActiveBetsReceipt",
    false
  ),
  isBettingModalOpen: get(store, "RaceProgram.startBetting"),
  showSilks: get(store, "capi.featureToggles.showSilks", false),
  firstTimeOnboardingToggle: get(
    store,
    "capi.featureToggles.firstTimeOnboarding"
  ),
  runnerTags: parseJSONCapiMessage(
    store,
    "capi.messages.handicappingRunnerFlags",
    []
  ).flags,
  wagerType: get(store, "RaceProgram.betType"),
  useGraphStatusV2: get(store, "capi.featureToggles.graphStatusV2", false),
  showRunnerUpdate: get(store, "capi.featureToggles.showRunnerUpdate", false),
  enableNewRacePage: get(store, "capi.featureToggles.enableNewRacePage", false),
  wagerTypeHelpHidden: get(
    store,
    "userData.preferences.wagerTypeHelpHidden",
    ""
  ),
  selectAllButtonLabel: get(store, "capi.messages.selectAllButtonLabel"),
  videoCarouselData: get(store, "RaceProgram.videoCarousel", {}),
  raceDate: get(store, "mtpStatus.raceDate", "")
}))(compose(graphql(RacecardQuery, ApolloOptions))(RaceCard));
